import ConditionalRender, { Experiment, Original } from '@/components/ConditionalRender'

import OriginalExpressDealDialog from './ExpressDealDialog'
import type { ExpressDealDialogProps } from './ExpressDealDialog.types'
import { HorizonExpressDealDialog } from './HorizonExpressDealDialog'

export const EXPRESS_DEAL_HORIZON_EXPERIMENT = 'USB_EXPRESS_DEAL_HORIZON'

export function ExpressDealDialogExperiment(props: ExpressDealDialogProps) {
  return (
    <ConditionalRender
      experimentCode={EXPRESS_DEAL_HORIZON_EXPERIMENT}
      triggerExperiment={() => props.isOpen}
    >
      <Original>
        <OriginalExpressDealDialog {...props} />
      </Original>
      <Experiment>
        <HorizonExpressDealDialog {...props} />
      </Experiment>
    </ConditionalRender>
  )
}
